import { DatabaseZap, Plus, Route } from "lucide-react";
import { MmcFrame } from "../../admin-framework/MmcFrame.js";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

export function DnsManagerApp({ activeMachine, app, onRunCommand }: SimulatorAppSurfaceProps) {
  const run = (commandType: string, capability: string, label: string, payload: Record<string, unknown>) => {
    void onRunCommand({ appId: app.id, capability, commandType, label, payload: { machineId: activeMachine, ...payload } });
  };

  return (
    <div className="fd-sim-app fd-sim-admin-tool">
      <MmcFrame
        title={app.title}
        actions={[
          { label: "New Zone", onClick: () => run("SERVER_DNS_CREATE_ZONE", "dns.zone.write", "New Zone", { replication: "domain", zoneName: "adv166.local", zoneType: "primary" }) },
          { label: "New Record", onClick: () => run("SERVER_DNS_ADD_RECORD", "dns.record.write", "New A Record", { recordName: "ws166", recordType: "A", value: "10.50.166.20", zoneName: "adv166.local" }) },
          { label: "Forwarders", onClick: () => run("SERVER_DNS_SET_FORWARDERS", "dns.zone.write", "Forwarders", { forwarders: ["10.50.10.10", "1.1.1.1"] }) }
        ]}
        columns={[
          { key: "name", label: "Name" },
          { key: "type", label: "Type" },
          { key: "data", label: "Data" }
        ]}
        rows={[
          { id: "ws166", values: { name: "ws166", type: "A", data: "10.50.166.20" }, onDoubleClick: () => run("SERVER_DNS_ADD_RECORD", "dns.record.write", "New A Record", { recordName: "ws166", recordType: "A", value: "10.50.166.20", zoneName: "adv166.local" }) },
          { id: "soa", values: { name: "@", type: "SOA", data: "SRV01.adv166.local" } },
          { id: "ldap", values: { name: "_ldap._tcp", type: "SRV", data: "SRV01.adv166.local" } }
        ]}
        tree={[
          { active: true, id: "server", icon: <DatabaseZap size={16} />, label: "SRV01" },
          { id: "forward", icon: <Plus size={16} />, label: "Forward Lookup Zones", onClick: () => run("SERVER_DNS_CREATE_ZONE", "dns.zone.write", "New Zone", { replication: "domain", zoneName: "adv166.local", zoneType: "primary" }) },
          { active: true, id: "zone", icon: <DatabaseZap size={16} />, label: "adv166.local" },
          { id: "reverse", icon: <Route size={16} />, label: "Reverse Lookup Zones" }
        ]}
      >
        <section className="fd-mmc-property-band">
          <button type="button" onClick={() => run("SERVER_DNS_UPDATE_RECORD", "dns.record.write", "Update Record", { recordName: "ws166", recordType: "A", value: "10.50.166.21", zoneName: "adv166.local" })}>Update record</button>
          <button type="button" onClick={() => run("SERVER_DNS_DELETE_RECORD", "dns.record.write", "Delete Record", { recordName: "oldws", recordType: "A", zoneName: "adv166.local" })}>Delete record</button>
        </section>
      </MmcFrame>
    </div>
  );
}
